import { useCallback } from "react";
import { useQuery } from "react-query";
import { getVatNumber } from "api/integrations";
import { App, Upload } from "antd";
import { useTranslation } from "react-i18next";
import { UploadProps } from "antd/lib";

export const useOpencxTrigger = () => {
  const triggerOpencx = useCallback(() => {
    const opencx: HTMLIFrameElement | null = document.querySelector("#opencx-root iframe");

    const triggerBtn: HTMLDivElement | null | undefined =
      opencx?.contentDocument?.body.querySelector('[data-component="trigger/btn"]');
    if (triggerBtn) {
      triggerBtn.click();
    }
  }, []);

  return { triggerOpencx };
};
export const useVatNumber = ({ enabled = true }) => {
  const { data, isSuccess } = useQuery({
    queryKey: ["getVatNumber"],
    queryFn: () => getVatNumber(),
    enabled,
  });
  return { vatNumber: data?.tax_numer, vatIsSuccess: isSuccess };
};

export const useFileUploaderHelpers = ({
  allowedFileTypes,
  maxSizeInMB,
}: {
  allowedFileTypes: string[];
  maxSizeInMB: number;
}) => {
  const { message } = App.useApp();
  const { t } = useTranslation();

  const beforeUpload: UploadProps["beforeUpload"] = (file) => {
    const isAllowedType = allowedFileTypes.includes(file.type);
    if (!isAllowedType) {
      message.error(t("frontend.validations.file_extension"));
    }
    const isLt2M = file.size / 1024 / 1024 < maxSizeInMB;
    if (!isLt2M) {
      message.error(t("frontend.validations.maximum_file_size", { sizeInMB: maxSizeInMB }));
    }

    if (!isAllowedType || !isLt2M) {
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const normalizeFile = (e: { fileList?: File[] } | File[]): File[] => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList || [];
  };

  return {
    beforeUpload,
    normalizeFile,
  };
};
